import { render, staticRenderFns } from "./VendorSidebar.vue?vue&type=template&id=56066a21"
import script from "./VendorSidebar.vue?vue&type=script&lang=ts"
export * from "./VendorSidebar.vue?vue&type=script&lang=ts"
import style0 from "./VendorSidebar.vue?vue&type=style&index=0&id=56066a21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports